import { Directive, Host, Optional, OnInit } from '@angular/core';
import { TreeSelect } from 'primeng/treeselect';
import { Select } from 'primeng/select';
import { MultiSelect } from 'primeng/multiselect';
import { AutoComplete } from 'primeng/autocomplete';
import { OverlayOptions, OverlayListenerOptions } from 'primeng/api';

/**
 * Universal directive that prevents PrimeNG overlay components from closing on scroll.
 * Automatically applied to all TreeSelect, Select, MultiSelect, and AutoComplete components.
 */
@Directive({
  selector: 'p-treeSelect, p-select, p-multiSelect, p-autoComplete',
  standalone: true
})
export class PreventOverlayCloseOnScrollDirective implements OnInit {

  constructor(
    @Optional() @Host() private treeSelect?: TreeSelect,
    @Optional() @Host() private select?: Select,
    @Optional() @Host() private multiSelect?: MultiSelect,
    @Optional() @Host() private autoComplete?: AutoComplete
  ) {}

  ngOnInit() {
    const overlayOptions: OverlayOptions = {
      listener: (event: Event, options?: OverlayListenerOptions) => {
        // Prevent overlay from closing on scroll events
        if (options?.type === 'scroll') {
          return false;
        }
        // Allow default behavior for other events
        return options?.valid !== false;
      }
    };

    // Apply to whichever component this directive is attached to
    if (this.treeSelect) {
      this.treeSelect.overlayOptions = overlayOptions;
    } else if (this.select) {
      this.select.overlayOptions = overlayOptions;
    } else if (this.multiSelect) {
      this.multiSelect.overlayOptions = overlayOptions;
    } else if (this.autoComplete) {
      this.autoComplete.overlayOptions = overlayOptions;
    }
  }
}